export enum DetectionStatus {
  DETECTED = 'detected',
  SUPPRESSION_SUCCESS = 'suppression_success',
  SUPPRESSION_FAILED = 'suppression_failed',
  SUPPRESSION_INITIATED = 'suppression_initiated',
  SUPPRESSION_IN_PROGRESS = 'suppression_in_progress',
  WHITELISTED = 'whitelisted',
  LOST = 'lost',
}
